<template>
<vx-card v-if="arrivalDate && arrivalDate !== 1">
  <div class="vx-card__title mb-6">
    <h3 class="text-center">Tu nueva vida comienza en:</h3>
  </div>
  <img src="@/assets/images/pages/nueva-vida-espana-cohen-y-aguirre.jpg" alt="coming-soon" class="mx-auto mb-2 w-1/2 md:w-1/3">
  <div class="count-down text-center" v-if="arrivalDate">
    <countdown :time="new Date(arrivalDate).getTime() - new Date().getTime()">
      <template slot-scope="props">
        <div class="single-counter">
          <span class="timer">{{ props.days }}</span>
          <span>Días</span>
        </div>
        <div class="single-counter">
          <span class="timer">{{ props.hours }}</span>
          <span>Horas</span>
        </div>
        <div class="single-counter">
          <span class="timer">{{ props.minutes }}</span>
          <span>Min</span>
        </div>
        <div class="single-counter">
          <span class="timer">{{ props.seconds }}</span>
          <span>Seg</span>
        </div>
      </template>
    </countdown>
  </div>
  <div class="count-down text-center" v-if="arrivalDate && arrivalDate === null">
    <template>
      <div class="single-counter">
        <span class="timer">0</span>
        <span>Días</span>
      </div>
      <div class="single-counter">
        <span class="timer">0</span>
        <span>Horas</span>
      </div>
      <div class="single-counter">
        <span class="timer">0</span>
        <span>Minutos</span>
      </div>
      <div class="single-counter">
        <span class="timer">0</span>
        <span>Segundos</span>
      </div>
    </template>
  </div>
</vx-card>
<vx-card v-else-if="arrivalDate === 1">
  <div class="vx-card__title mb-6">
    <h2 class="text-center">¡Ya has llegado a España!</h2>
  </div>
  <img src="@/assets/images/pages/arriving-to-spain.jpg" alt="coming-soon" class="mx-auto mb-2 w-1/2 md:w-1/3">
  <div class="vx-card__title mb-6">
    <h3 class="text-center">{{ arrivalDateCorrected }}</h3>
  </div>
</vx-card>
</template>
<script>
import CalendarView from '@/components/calendar/CalendarView.vue'
import CalendarViewHeader from '@/components/calendar/CalendarViewHeader.vue'
require('vue-simple-calendar/static/css/default.css')
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'
import VueCountdown from '@chenfengyuan/vue-countdown'
export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    'countdown': VueCountdown
  },
  data () {
    return {
      id_client: null,
      userInfo: null,
      //calendar
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      en,
      es,
      url: '',
      calendarView: 'month'
    }
  },
  computed: {
    arrivalDate () {
      const arrivalDate = this.$store.state.arrivalDate
      if (arrivalDate === 'N/A') return null
      if (arrivalDate === 'null') return null
      if (arrivalDate === null) return null
      const arrivalDateEdited = new Date(arrivalDate)
      const todayDate = new Date()
      const diff = arrivalDateEdited - todayDate
      if (diff >= 0) {
        arrivalDateEdited.setDate(arrivalDateEdited.getDate() + 1) //Se corrige date que viene del Back
        return `${new Date(arrivalDateEdited).getMonth() + 1}/${new Date(arrivalDateEdited).getDate()}/${new Date(arrivalDateEdited).getFullYear()}`
      } else {
        return 1
      }
    },
    arrivalDateCorrected () {
      const arrivalDate = this.$store.state.arrivalDate
      return arrivalDate
    }
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || this.$store.state.AppActiveUser
    this.id_client = this.userInfo.client_id
    this.$store.dispatch('fecthCustomerAddedServicesInmigration', this.userInfo)
    this.$store.dispatch('fetchArrivalDate', this.id_client)
  }
}
</script>
